import { render, staticRenderFns } from "./DisplayCoupon.vue?vue&type=template&id=3f1cc1a1&scoped=true&"
import script from "./DisplayCoupon.vue?vue&type=script&lang=js&"
export * from "./DisplayCoupon.vue?vue&type=script&lang=js&"
import style0 from "./DisplayCoupon.vue?vue&type=style&index=0&id=3f1cc1a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1cc1a1",
  null
  
)

export default component.exports